import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { LandingPage } from './pages/LandingPage'
import { IntelligenceSolutionsPage } from './pages/IntelligenceSolutionsPage'
import { UseCasesPage } from './pages/UseCasesPage'
import { OnboardingInfoPage } from './pages/OnboardingInfoPage'
import { AuthPage } from './pages/AuthPage'
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage'
import { TermsOfServicePage } from './pages/TermsOfServicePage'
import { CookiePolicyPage } from './pages/CookiePolicyPage'
import { PaymentPage } from './pages/PaymentPage'
import { PaymentSuccessPage } from './pages/PaymentSuccessPage'
import { AdminProfilesPage } from './pages/AdminProfilesPage'
import { AdminDashboardPage } from './pages/AdminDashboardPage'
import { WebhookTestHarness } from './pages/WebhookTestHarness'
import { OnboardingFlow } from './features/onboarding/OnboardingFlow'
import { ToastContainer } from './components/ui/ToastContainer'
import { useAuthStore } from './stores/authStore'
import { ProtectedRoute } from './components/auth/ProtectedRoute'

function App() {
  const { checkAuth } = useAuthStore()

  useEffect(() => {
    // Check authentication status on app load
    checkAuth()
  }, [])
  return (
    <Router>
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/intelligence-solutions" element={<IntelligenceSolutionsPage />} />
          <Route path="/use-cases" element={<UseCasesPage />} />
          <Route path="/onboarding-info" element={<OnboardingInfoPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/onboarding/success" element={<PaymentSuccessPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/cookies" element={<CookiePolicyPage />} />
          <Route path="/test-harness" element={<WebhookTestHarness />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute requiredRoles={['super_admin', 'admin']}>
              <AdminDashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/admin/profiles" element={
            <ProtectedRoute requiredRoles={['super_admin', 'admin']}>
              <AdminProfilesPage />
            </ProtectedRoute>
          } />
          <Route path="/onboarding" element={
            <div className="min-h-screen bg-background">
              <OnboardingFlow />
            </div>
          } />
        </Routes>
        <ToastContainer />
      </div>
    </Router>
  )
}

export default App